import { LocalStorage } from './storage/LocalStorage';

export const getCartTokenHeaders = () => {
    const cartToken = LocalStorage.get('x-klickly-cart-token');

    const headers = {};

    if (cartToken) {
        headers['x-klickly-cart-token'] = cartToken;
    }

    return headers;
};
